import $ from 'jquery';
import _ from 'underscore';

import Backbone from 'backbone';
import View from './view';

import { asc, desc } from '../collection/sort';
import { find } from '../utils/strings';
import Collection from '../collection';





export default View.extend( {

    initialize(options = {}) {
        View.prototype.initialize.call( this, options );

        if (options.collection) 
            this.grab( options.collection );
    },
    
    className: 'grid',
    
    events: {
        
        'dblclick tbody tr': function(e) {
            let index = parseInt( e.currentTarget.dataset.index );
            this.trigger( 'action:default', 
                index, 
                this.options.collection.at( index ) );
        },

        'mousedown tbody tr': function(e) {
            if (this.$( e.originalEvent.target ).is( '[type=text], [type=number]' ))
                return;
            else if (typeof this.options.dragMode === 'function' && this.options.dragMode() || 
                     typeof this.options.dragMode !== 'function' && this.options.dragMode)
                // hack: do not re-focus but make grid
                // look like it's focused
                setTimeout( () => this.$el.addClass( '__focused' ), 0 );
            else
                // blocks drag start
                e.preventDefault(),
                this.focus();
        },

        'dragstart tbody tr': function(e) {
            const arr = this.$( 'tbody tr' )
                .get()
                .map( (row, index) => [index, row] );

            const [[index, row]] = arr
                .filter( ([index, row]) => row == e.currentTarget );

            this.sourceIndex = index;
            this.startY = e.pageY;
            this.prevY = e.pageY;

            this.$( 'tbody tr' ).get()
                .forEach( (row, index) => row.dataset.newIndex = index );

            this.trigger( 'click-activate', +index );

            this.$( row ).addClass( '--drag-target' );
        },

        'dragover tbody tr': function(e) {
            e.preventDefault();
            e.originalEvent.dataTransfer.dropEffect = 'move';

            const deltaY = e.pageY - this.startY;
            const deltaIndex = deltaY < 0
                ? (deltaY - 24.5) / 49 | 0
                : (deltaY + 24.5) / 49 | 0;

            if (e.pageY > this.prevY)
                this.$( '.--drag-target' ).insertAfter(
                    this.$( 'tbody tr' ).eq( +this.sourceIndex + deltaIndex ) )

            if (e.pageY < this.prevY)
                this.$( '.--drag-target' ).insertBefore(
                    this.$( 'tbody tr' ).eq( +this.sourceIndex + deltaIndex ) )

            this.prevY = e.pageY;
        },

        'dragend tbody tr': function(/*e*/) {
            this.$( 'tbody tr' ).get()
                .sort( (rowA, rowB) =>
                    rowA.dataset.newIndex - rowB.dataset.newIndex )
                .reverse()
                .forEach( row =>
                    this.$( row ).prependTo( this.$( 'tbody' ) ) );

            this.$( '.--drag-target').removeClass( '--drag-target' );

            this.focus();
        },

        'drop tbody tr': function(/*e*/) {
            this.$( 'tbody tr' ).get()
                .forEach( (row, index) => row.dataset.newIndex = index );

            this.trigger( 'rows:order', this.$( 'tbody tr' )
                .map( (index, el) => +el.dataset.index )
                .get() );
        },
        
        'click tbody tr': function(e) {
            const [[row, index]] = this.$( 'tbody tr' ).get()
                .map( row => [row, row.dataset.index] )
                .filter( ([row]) => row == e.currentTarget );

            this.trigger( 'click-activate', index );
        },
        
        'keydown [data-id="focus-holder"]': function(e) {
            switch (e.keyCode) {
                case 38: this.trigger( 'prevRow' ); 
                    e.preventDefault(); break;
                case 40: this.trigger( 'nextRow' ); 
                    e.preventDefault(); break;
            }
        },
        
        'keyup [data-id="focus-holder"]': function(e) {
            switch (e.keyCode) {
                case 13: this.trigger( 'action:default' ); 
                    break;
                // i 
                case 73: e.ctrlKey && this.trigger( 'action:create' );
                    break;
                // del 
                case 46: this.trigger( 'action:destroy' );
                    break; 
            }
        },
        
        'focus [data-id="focus-holder"]': function(e) {
            if (this.$el.hasClass( '__focused' ))
                return;

            Backbone.$( '.__focused' ).removeClass( '__focused' );
            this.$el.addClass( '__focused' );
        },
        
        'blur [data-id="focus-holder"]': function(e) {
            this.$el.removeClass( '__focused' );
        },

    },
    
    serialize() {
        const { collection, striped, direction, sort, } = this.options;
        return { 
            items: collection.serialize(), 
            striped, class: this.options.class,
            direction, sort,
        };
    },
    
    grab(collection) {
        // "sync" is full reload from server;
		this.listenTo( collection, 'sync reset', () => 
                this.render( { items: collection.serialize() } ) );
            
        // "poke" is model's change;
        // update grid (re-render rows)
        // this.listenTo( collection, 'merge', () => console.log( 'merge' ) );
        // this.listenTo( collection, 'poke', () => console.log( 'poke' ) );
        this.listenTo( collection, 'poke',
            (/*index*/) => this.update( { items: collection.serialize() } ) );

        // "activate deactivate" is change of 
        // current row's position;
        // update active row
        this.listenTo( collection, 'activate deactivate', 
            () => this.updateActiveRow( collection ) );

        // pass events from UI into collection
        collection.listenTo( this, 'click-activate',
            index => collection.activate( index ) );
        collection.listenTo( this, 'prevRow',
            () => collection.prevRow() );
        collection.listenTo( this, 'nextRow',
            () => collection.nextRow() );
            
        return this;
    },
    
    ungrab(collection) {
        this.stopListening( collection );
        collection.stopListening( this );
    },
    
    update(context) {
        return this.html( context ).then( html => {
            let tbody = $( html ).find( 'tbody' );
            this.$( 'tbody' ).replaceWith( tbody );
        } );
    },
    
    updateActiveRow(collection) {
        this.$( 'tr.info' ).removeClass( 'info' );
        let index = collection.activeRow();
        this.$( `tbody tr[data-index="${index}"]` ).addClass( 'info' );
        if (index || index === 0)
            this.trigger( 'activate', index, collection.current() );
        else
            this.trigger( 'deactivate' );
    },
    
    focus() {
        this.$( '[data-id="focus-holder"]' )[0].focus();
        return this;
    }
    
}, {

    sort(params /* { sort, direction } */, sourceColl, destColl) {
        const fn = 'asc' === params.direction ? asc : desc;
        const columns = params.sort || ['name', 'title', 'id'];
        return fn( sourceColl.models || sourceColl, columns )
            .then( sortedModels => destColl.reset( sortedModels ) )
            .then( () => destColl );
    },

    filter({ search = '', page = 1, limit = 10, activeId }, 
        cluster,
        source, filtered, dest,
        customFilterFn = () => true) {

        filtered = filtered || new Collection();
        dest = dest || new Collection();

        const models = source.models
            .filter( model =>
                !cluster || !model.get( 'cluster' ) && !model.get( 'cluster_id' ) ||
                // role
                model.get( 'cluster' ) && model.get( 'cluster' ).id == cluster.id ||
                // org
                model.get( 'cluster_id' ) == cluster.id )
            .filter( model => 
                find( [model.id, model.get( 'no' ), model.get( 'name' ), model.get( 'title' )], search ) )
            .filter( 
                customFilterFn );
    
        dest.total = filtered.total = models.length;
        dest.page = filtered.page = page;
        dest.limit = filtered.limit = limit;
        dest.npages = (dest.total / dest.limit | 0) + (dest.total % dest.limit == 0 ? 0 : 1);
        
        filtered.reset( models );
        dest.reset( models
            .filter( (_, index) => index >= limit * (page - 1) &&
                                   index <  limit * page ) );

        // setTimeout, because 
        //  - render() will be called after reset()
        //  - render() is async
        setTimeout( () => {
            const activeIndex = dest.findIndex( model => +model.id === +activeId );
            if (activeIndex > -1)
                dest.activate( activeIndex );
            else
                dest.restoreActive();
        }, 0 );

        return {
            filtered, dest,
        }
    },

} );


// WEBPACK FOOTER //
// ./src/js/view/grid.js